var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStringicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 24L-1.90735e-06 24L-7.42491e-07 10.6756L5.21307 1.22659e-06L11.6935 1.79313e-06L6.50653 10.6756L13 10.6756L13 24Z",
    fill: "#FF9213"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24L18 24L18 10.6756L23.2131 1.22659e-06L29.6935 1.79313e-06L24.5065 10.6756L31 10.6756L31 24Z",
    fill: "#FF9213"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStringicon);
export default __webpack_public_path__ + "static/media/stringicon.98559ce439efb6403c60e33fb0d14553.svg";
export { ForwardRef as ReactComponent };